import { render } from "./node-chapter-3.vue?vue&type=template&id=5b514bb8"
import script from "./node-chapter-3.vue?vue&type=script&lang=js"
export * from "./node-chapter-3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__